import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { COMMON_API } from '../../CommonAPI';

const Portfolio = () => {
    const [portfolios, setPortfolios] = useState([]);

    useEffect(() => {
        const fetchPortfolios = async () => {
            try {
                const token = sessionStorage.getItem("authToken");
                const response = await axios.get(`${COMMON_API}/api/portfolio/get-portfolio`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setPortfolios(response.data);
            } catch (error) {
                toast.error("Error fetching portfolios");
            }
        };
        fetchPortfolios();
    }, []);

    const deletePortfolio = async (portfolioId) => {
        try {
            const token = sessionStorage.getItem("authToken");
            await axios.delete(`${COMMON_API}/api/portfolio/delete-portfolio/${portfolioId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setPortfolios(prev => prev.filter(item => item.id !== portfolioId));
            toast.success("Portfolio deleted successfully");
        } catch (error) {
            toast.error("Error deleting portfolio");
        }
    };

    return (
        <div className="ml-64 p-8 bg-gray-100 min-h-screen">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-3xl font-semibold text-gray-800">Portfolio List</h2>
                <Link
                    to="/add_portfolio"
                    className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
                >
                    Add Portfolio
                </Link>
            </div>
            <div className="overflow-x-auto bg-white rounded shadow">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">S.No</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Category</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {portfolios.map((portfolio, index) => (
                            <tr key={portfolio.id}>
                                <td className="px-6 py-4 whitespace-nowrap">{index + 1}</td>
                                <td className="px-6 py-4">{portfolio.category}</td>
                                <td className="px-6 py-4 flex gap-3">
                                    <button
                                        onClick={() => deletePortfolio(portfolio.id)}
                                        className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
                                    >
                                        Delete
                                    </button>
                                    <Link
                                        to={`/edit_portfolio/${portfolio.id}`}
                                        className="bg-yellow-400 hover:bg-yellow-500 text-white px-3 py-1 rounded"
                                    >
                                        Edit
                                    </Link>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Portfolio;
